import createInformationModal from './createInformationModal';
import { ID_SAFE_FLOOR_INFO } from '../../utils/dom-element-ids';

// Configuration for Safe Floor Information Modal
const SAFE_FLOOR_MODAL_CONFIG = {
  titleKey: 'lbl.safe-floor',
  informationList: [
    {
      item: 'lbl.safe-floor',
      definition: 'lbl.safe-floor-definition',
    },
  ],
  iconId: ID_SAFE_FLOOR_INFO,
  wrapperClassName: 'pb3-sm',
};

// Generate component from configuration
const SafeFloorInformationModal = createInformationModal(SAFE_FLOOR_MODAL_CONFIG);

export default SafeFloorInformationModal;
